import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CULTURE_ROUTE_PARAM, CultureKeyType } from '@constants/app.constants';
import { Store } from '@ngrx/store';
import { selectRouteParam } from '@selectors/router.selector';
import { Observable } from 'rxjs';
import { LetDirective } from 'src/app/directives/app-let.directive';

@Component({
  selector: 'app-locale-date',
  standalone: true,
  imports: [CommonModule, LetDirective],
  templateUrl: './locale-date.component.html',
  styleUrls: ['./locale-date.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocaleDateComponent {
  @Input() date: string | Date;
  @Input() secondDate?: string | Date;
  @Input() format: string;

  culture$ = this.store.select(
    selectRouteParam(CULTURE_ROUTE_PARAM),
  ) as Observable<CultureKeyType | undefined>;

  constructor(private store: Store) {}
}
